<template>
    <!-- 无鉴权头，只提供登录能力 -->
    <!-- 主要用于非999(无供货规则)商登录参与PBBOM、招投标页面 -->
    <div class="supplier-customHeader-layout">
        <div
            v-if="!hideHeader"
            class="header"
        >
            <div class="header-left">
                <img
                    src="https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/xxlogo.png"
                />
                <span class="header-logo-line">|</span>
                <span>供应商服务系统</span>
                <span
                    v-if="!isIntermediatePage"
                    class="link-intermediate-page"
                    @click="goIntermediatePage"
                >中间页</span>
            </div>
            <div class="header-right">
                <span>{{ operator }}</span>
                <mc-button
                    type="text"
                    class="logout-btn"
                    @click="logout"
                >
                    退出登录
                </mc-button>
            </div>
        </div>
        <div
            class="content"
            :class="{'no-header': hideHeader}"
        >
            <slot name="content">
            </slot>
        </div>
    </div>
</template>
<script>
import {
    ref, onMounted,
} from '@vue/composition-api';
import { linkTo, parseQuery } from '@mcfe/tools';
import { MERCHANT_STATE, getSourceParamsFromSessionStorage, getMerchantState } from 'utils';
import { getBizAccountApi } from './api';

const {
    source, entryPoint, ytType: ytTypeQuery, hzType: hzTypeQuery,
} = parseQuery();
const { ytType: localYtType, hzType: localHzType } = getSourceParamsFromSessionStorage();

const ytType = +ytTypeQuery || +localYtType;
const hzType = +hzTypeQuery || +localHzType;

export default {
    name: 'CustomHeaderLayout',
    props: {
        isIntermediatePage: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const operator = ref('');
        const hideHeader = ref(false);

        // 退出登录
        const logout = () => {
            // 清楚掉sessionStorage中的sourceParams，因为登出后，需要重置业态和合作模式，防止下次登录时，出现问题
            sessionStorage.removeItem('sourceParams');
            let logoutUrl = 'noMatch';
            const nodeEnv = process.env.NODE_ENV;
            if (nodeEnv === 'production') {
                logoutUrl = '/api/carrier/epassport/logout609';
            } else if (nodeEnv === 'staging') {
                logoutUrl = '/api/carrier/epassport/logout367';
            } else {
                logoutUrl = '/api/carrier/epassport/logout855';
            }
            logoutUrl = `${logoutUrl}?redirect_uri=${encodeURIComponent('/login.html')}`;
            window.location.href = `${window.location.origin}${logoutUrl}`;
        };
        // 跳转中间页
        const goIntermediatePage = () => {
            linkTo('/vss/intermediatePage.html', { source, entryPoint });
        };

        onMounted(async () => {
            const { state, needBusinessSelect } = await getMerchantState({ ytType, hzType });

            if (needBusinessSelect) {
                linkTo('/vss/supplier/businessSelect.html', { from: 'login' });
            }

            hideHeader.value = state === MERCHANT_STATE.BOUND_MERCHANT; // 已绑定供货规则的供应商不需要展示自定义头，由主应用提供
            if (!hideHeader.value) {
                const { login } = await getBizAccountApi();
                operator.value = login;
            }
            emit('currentStateChange', state);

            const intermediatePageRoutes = {
                // 999-已准入绑定了供货规则
                [MERCHANT_STATE.BOUND_MERCHANT]: '/index.html',
            };

            // isIntermediatePage-中间页跳转到首页
            // 其他页面如招投标、PBBOM页面不做跳转，页面内有判断跳转
            const route = props.isIntermediatePage
                ? intermediatePageRoutes[state]
                : null;
                // 非999-直接按中间页跳转逻辑
            if (route) {
                linkTo(route, { source, entryPoint });
            }
        });


        return {
            operator,
            logout,
            hideHeader,
            goIntermediatePage,
        };
    },
};


</script>
<style>
* {
    margin: 0;
    padding: 0;
}
</style>
<style lang="scss" scoped>
.supplier-customHeader-layout {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #F6F6F8;
    height: 100%;
    overflow-y: auto;
    .header {
        display: flex;
        flex-direction: row;
        height: 60px;
        align-items: center;
        justify-content: space-between;
        background-color: #01a65c;
        padding: 13px 12px 13px 24px;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 10;
        .header-left {
            display: flex;
            align-items: center;
            img {
                display: inline-block;
                width: 118px;
            }
            span {
                cursor: pointer;
                font-size: 14px;
                font-weight: 700;
                line-height: 60px;
                color: #fff;
            }
            .header-logo-line {
                margin: 0 12px;
                color: #fff;
            }
        }
        .header-right {
            span {
                font-size: 14px;
                color: #fff;
            }
            ::v-deep .mtd-btn-text {
                color: #fff;
            }
        }
    }
    .content {
        width: 100%;
        padding: 80px 20px 20px 20px;
        flex: 1;
        background-color: #fff;
    }
    .no-header {
        padding-top: 20px;
    }
    .link-intermediate-page {
        cursor: pointer;
        margin-left: 15px;
    }
    .affix {
        left: 0;
    }
}
</style>
